import store from '@/store'

export const isUserLoggedIn = () => {
  return !!store.state.app.userData
}

export const isTokenExpired = (to) => {
  const user = store.state.app.userData
  // If no user, treat it as not expired(so can enter public pages as forgot password)
  if (!user) return false
  // if user check expired
  const now = Math.floor(Date.now() / 1000)
  const expires = user?.expires ?? 0
  // if expired log out
  if (expires > 0 && expires < now) {
    return true
  }
  return false
}

export const getUserData = () => {
  return store.state.app.userData
}

export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return { name: 'landing' }
  if (userRole === 'client') return { name: 'landing' }
  return { name: 'auth-login' }
}
